module.exports = __webpack_public_path__ + "0f7d9772dda9cce40701aab576da1251.pdf";